// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SsTIR","left":"styles_left__bWPZu","desktopActions":"styles_desktopActions__LcdTd","title":"styles_title__2LzDW"};